// Authenticated layout. Bounces to /login when no admin session is
// present. Shell shape is identical to web-backoffice: 240-px sidebar
// + main column (sticky topbar + scrolling content) so an operator
// switching between the two apps keeps the same muscle memory.
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useState } from "react";
import { CurrencyPresentationProvider } from "@/components/currency/CurrencyPresentationProvider";
import { Sidebar } from "@/components/layout/Sidebar";
import { TopBar } from "@/components/layout/TopBar";
import { fetchMeOrNull } from "@/lib/auth";
import { keys } from "@/lib/queries";

export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context, location }) => {
    const me = await context.queryClient.ensureQueryData({
      queryKey: keys.me(),
      queryFn: fetchMeOrNull,
      staleTime: 5_000,
    });
    if (!me) {
      throw redirect({
        to: "/login",
        search: { redirect: location.href },
      });
    }
  },
  component: AppLayout,
});

function AppLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  // Currency presentation wraps the whole authenticated shell: the operator
  // configuration Backoffice writes has to reach every figure here, not only
  // the pages that happen to fetch the registry themselves. It renders its
  // children immediately — the seed is a complete presentation — so this adds
  // no loading state to the shell.
  return (
    <CurrencyPresentationProvider>
      <div className="admin-shell">
        <Sidebar
          mobileOpen={mobileNavOpen}
          onMobileClose={() => setMobileNavOpen(false)}
        />
        <div className="admin-main">
          <TopBar onMenuClick={() => setMobileNavOpen(true)} />
          <main className="admin-main-content">
            <Outlet />
          </main>
        </div>
      </div>
    </CurrencyPresentationProvider>
  );
}
